module.exports = __webpack_public_path__ + "img/erbil.c2a870d.webp";